(() => {
  const emit = (eventName, detail = {}) => {
    document.dispatchEvent(new CustomEvent(eventName, { detail }));

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: eventName, ...detail });
    }
  };

  window.afvCRO = window.afvCRO || {};
  window.afvCRO.emit = emit;

  const patchQuickViewLoader = () => {
    const QuickViewElement = customElements.get('quick-view');
    if (!QuickViewElement || QuickViewElement.prototype.afvSectionLoader) return;

    QuickViewElement.prototype.afvSectionLoader = true;
    QuickViewElement.prototype.quickview = function () {
      const drawerContent = this.querySelector(this.selector);
      const productUrl = this.getAttribute('data-product-url').split('?')[0];
      const modalUrl = `${productUrl}?view=modal`;

      fetch(modalUrl, { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) throw new Error(`Quick Add returned ${response.status}`);
          return response.text();
        })
        .then((responseText) => {
          const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const productElement = parsedHTML.querySelector(this.selector);
          if (!productElement) throw new Error('Quick Add section was missing');

          this.setInnerHTML(drawerContent, productElement.innerHTML);
          theme.a11y.trapFocus(this, this.focusElement);
          if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
          document.dispatchEvent(new CustomEvent('quickview:loaded', {
            detail: { productUrl: this.getAttribute('data-product-url') }
          }));
        })
        .catch((error) => {
          drawerContent.replaceChildren();
          const fallback = document.createElement('div');
          const message = document.createElement('p');
          const link = document.createElement('a');
          fallback.className = 'afv-quick-add-fallback';
          message.textContent = 'Quick Add could not load this item.';
          link.className = 'button button--primary';
          link.href = productUrl;
          link.textContent = 'VIEW PRODUCT';
          fallback.append(message, link);
          drawerContent.appendChild(fallback);
          emit('afv_quick_add_error', { message: error.message });
        });
    };
  };

  patchQuickViewLoader();

  let quickAddPending = false;

  const prepareQuickAddPicker = () => {
    const modal = Array.from(document.querySelectorAll('quick-view')).find(
      (element) => !element.hidden && element.querySelector('variant-picker')
    );
    if (!modal) return;

    if (modal.afvPickerObserver) modal.afvPickerObserver.disconnect();
    const selectedOptions = new Set();
    const productInfo = modal.querySelector('product-info');
    const prompt = document.createElement('p');
    prompt.className = 'afv-quick-add-prompt';
    prompt.setAttribute('role', 'status');
    prompt.textContent = 'Select each product option to continue.';

    const initialPicker = modal.querySelector('variant-picker');
    initialPicker.parentElement.insertBefore(prompt, initialPicker);

    const sanitizePicker = () => {
      const picker = modal.querySelector('variant-picker');
      if (!picker) return;

      const optionGroups = Array.from(picker.querySelectorAll('fieldset, select'));
      optionGroups.forEach((group) => {
        const optionKey = group.dataset.optionIndex || group.name || group.id;
        if (selectedOptions.has(optionKey)) return;

        if (group.matches('select')) {
          group.selectedIndex = -1;
          group.querySelectorAll('option[selected]').forEach((option) => option.removeAttribute('selected'));
        } else {
          group.querySelectorAll('input:checked, input[checked]').forEach((input) => {
            input.checked = false;
            input.removeAttribute('checked');
          });
        }
      });

      const allSelected = optionGroups.length > 0 && optionGroups.every((group) => {
        const optionKey = group.dataset.optionIndex || group.name || group.id;
        if (!selectedOptions.has(optionKey)) return false;
        return group.matches('select') ? Boolean(group.value) : Boolean(group.querySelector('input:checked'));
      });

      const form = productInfo
        ? document.forms[productInfo.getAttribute('form')]
        : modal.querySelector('form[is="product-form"]');
      const variantInput = form ? form.querySelector('[name="id"]') : null;
      const submitButton = form ? form.querySelector('[type="submit"]') : null;

      prompt.hidden = allSelected;
      if (!allSelected) {
        if (variantInput) variantInput.value = '';
        if (submitButton) {
          submitButton.setAttribute('disabled', '');
          submitButton.setAttribute('aria-disabled', 'true');
          const submitLabel = submitButton.querySelector('.btn-text > span, .btn-text');
          if (submitLabel && submitLabel.textContent.trim() !== 'SELECT OPTIONS') {
            submitLabel.textContent = 'SELECT OPTIONS';
          }
        }
      }
    };

    modal.addEventListener('change', (event) => {
      const group = event.target.closest('fieldset, select');
      if (group) {
        selectedOptions.add(group.dataset.optionIndex || group.name || group.id);
        emit('afv_quick_add_variant_selected', {
          option_name: group.dataset.optionIndex || group.name || group.id,
          option_value: event.target.value || ''
        });
      }
      sanitizePicker();
    }, true);

    const observer = new MutationObserver(sanitizePicker);
    observer.observe(modal.querySelector('.quick-view__content'), { childList: true, subtree: true });
    modal.afvPickerObserver = observer;
    sanitizePicker();
  };

  document.addEventListener('quickview:loaded', prepareQuickAddPicker);

  document.addEventListener('submit', (event) => {
    if (event.target.closest('.template-collection .quick-add, .template-index .quick-add, quick-view')) {
      quickAddPending = true;
    }
  }, true);

  document.addEventListener('ajaxProduct:added', () => {
    if (!quickAddPending) return;
    quickAddPending = false;
    emit('afv_quick_add_success');
  });

  document.addEventListener('ajaxProduct:error', (event) => {
    if (!quickAddPending) return;
    quickAddPending = false;
    emit('afv_quick_add_error', {
      message: (event.detail && event.detail.errorMessage) || 'Unable to add item'
    });
  });

  let shippingThresholdReached = null;

  const syncShippingThreshold = (trackTransition = false) => {
    const progress = document.querySelector('[data-afv-shipping-progress]');
    const reached = progress ? progress.dataset.thresholdReached === 'true' : false;

    if (trackTransition && reached && shippingThresholdReached === false) {
      emit('afv_shipping_threshold_reached', {
        cart_total: Number(progress.dataset.cartTotal || 0),
        threshold: Number(progress.dataset.threshold || 0),
        currency: 'USD'
      });
    }

    shippingThresholdReached = reached;
  };

  syncShippingThreshold();
  document.addEventListener('cart:updated', () => syncShippingThreshold(true));

  const cartDrawer = document.getElementById('CartDrawer');
  if (cartDrawer) {
    new MutationObserver(() => syncShippingThreshold(true)).observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('click', (event) => {
    const searchTrigger = event.target.closest('.search-drawer-button');
    if (searchTrigger) emit('afv_search_open');

    const searchResult = event.target.closest('[data-afv-search-result]');
    if (searchResult) {
      emit('afv_predictive_search_result_click', {
        result_type: searchResult.dataset.afvSearchResultType || 'unknown',
        context: searchResult.dataset.afvSearchContext || 'search',
        destination: searchResult.href || ''
      });
    }

    const quickAddTrigger = event.target.closest('.template-collection .quick-add button, .template-index .quick-add button');
    if (!quickAddTrigger) return;

    emit('afv_quick_add_open', {
      mode: quickAddTrigger.hasAttribute('aria-controls') ? 'variant-selector' : 'direct'
    });
  });
})();
